var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[(_vm.editing)?_c('PropertyWindow',[_c(_vm.selectedItem?.settings?.component_property_window,{tag:"component"})],1):_vm._e(),(_vm.editing)?_c('LeftMenu',{attrs:{"tools":_vm.herramientas}}):_vm._e(),(_vm.actualPage())?_c('ScadaPage'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }